import _ from 'lodash'

export const getTestingItems = state => _.get(state, 'testingActions.items', [])
export const getItemsLoading = state => _.get(state, 'testingActions.loading', false)

// attachments
export const getTestingAttachments = state => _.get(state, 'testingActions.attachments', [])
export const getAttachmentsLoading = state =>
  _.get(state, 'testingActions.loadingAttachments', false)
export const getAttachmentUploading = state =>
  _.get(state, 'testingActions.uploadingAttachment', false)
export const getAttachmentDeleting = state =>
  _.get(state, 'testingActions.deletingAttachment', false)



// WEBPACK FOOTER //
// ./src/selectors/job/testing.js